import React, { useState } from 'react';
import { Menu, X, Phone, Mail } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_flavor-rolls/artifacts/09tli7zx_IMG_3971.jpeg" 
              alt="Roll Up Lumpia Co. Logo" 
              className="h-16 w-auto"
            />
            <div className="ml-4 hidden sm:block">
              <h1 className="text-xl font-bold text-gray-900">Roll Up Lumpia Co.</h1>
              <p className="text-sm text-gray-700">El Mirage, AZ</p>
            </div>
          </div>

          {/* Contact Info - Desktop */}
          <div className="hidden lg:flex items-center space-x-6 text-gray-900">
            <div className="flex items-center space-x-2">
              <Phone className="h-4 w-4" />
              <span className="font-medium">(480) 744-9683</span>
            </div>
            <div className="flex items-center space-x-2">
              <Mail className="h-4 w-4" />
              <span className="font-medium">rolluplumpiaco@gmail.com</span>
            </div>
          </div>

          {/* Navigation - Desktop */}
          <nav className="hidden md:flex space-x-8">
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-gray-900 hover:text-blue-600 font-medium transition-colors"
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('menu')} 
              className="text-gray-900 hover:text-blue-600 font-medium transition-colors"
            >
              Menu
            </button>
            <button 
              onClick={() => scrollToSection('catering')} 
              className="text-gray-900 hover:text-blue-600 font-medium transition-colors"
            >
              Catering
            </button>
            <button 
              onClick={() => scrollToSection('gallery')} 
              className="text-gray-900 hover:text-blue-600 font-medium transition-colors"
            >
              Gallery
            </button>
            <button 
              onClick={() => scrollToSection('reviews')} 
              className="text-gray-900 hover:text-blue-600 font-medium transition-colors"
            >
              Reviews
            </button>
            <button 
              onClick={() => scrollToSection('contact')} 
              className="bg-yellow-400 text-gray-900 px-4 py-2 rounded-lg font-medium hover:bg-yellow-300 transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 rounded-md text-gray-900 hover:text-blue-600"
          >
            {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden border-t border-yellow-200 py-4">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('about')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                About
              </button>
              <button 
                onClick={() => scrollToSection('menu')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                Menu
              </button>
              <button 
                onClick={() => scrollToSection('catering')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                Catering
              </button>
              <button 
                onClick={() => scrollToSection('gallery')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                Gallery
              </button>
              <button 
                onClick={() => scrollToSection('reviews')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                Reviews
              </button>
              <button 
                onClick={() => scrollToSection('contact')} 
                className="text-left text-gray-900 hover:text-blue-600 font-medium py-2"
              >
                Contact
              </button>
              
              {/* Mobile Contact Info */}
              <div className="pt-4 border-t border-yellow-200">
                <div className="flex items-center space-x-2 mb-2">
                  <Phone className="h-4 w-4 text-gray-900" />
                  <span className="text-sm font-medium text-gray-900">(480) 744-9683</span>
                </div>
                <div className="flex items-center space-x-2">
                  <Mail className="h-4 w-4 text-gray-900" />
                  <span className="text-sm font-medium text-gray-900">rolluplumpiaco@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;